export default __webpack_public_path__ + "static/media/feb1.84104c00.jpg";